import dayjs from 'dayjs';

import type {ProposedMembership} from '../../../stores/Invites/types';
import type {IProgramInviteDataModel} from './types';

import {datetimeObjToISOString} from '../../../../../utils/datetime';
import {getCourseLabel} from '../../../../../utils/entity/course';
import {getFileSrc} from '../../../../../utils/entity/file';

export class ProposedMembershipModel implements IProgramInviteDataModel {
  constructor(public membership: ProposedMembership) {}

  get avatar() {
    return getFileSrc(this.membership.user.avatar, 250).url;
  }

  get courseDates() {
    return getCourseLabel(this.membership.course);
  }

  get courseLabel() {
    return getCourseLabel(this.membership.course);
  }

  get initialEmail() {
    return this.membership.invite_data?.email ?? undefined;
  }

  get isInviteByEmail() {
    return false;
  }

  get label() {
    return dayjs(datetimeObjToISOString(this.membership.created)).format('lll');
  }

  get message() {
    return '';
  }

  get name() {
    return this.membership.user.name;
  }
}
